var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-chess-3392450",
    transform: "translate(-286.854 -37.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247980",
    "data-name": "Path 247980",
    d: "M432.5,534.052H423.53c.26-.283,2.195-2.653,2.52-10.812h4.056A53.9,53.9,0,0,0,432.5,534.052Z",
    transform: "translate(-133.17 -474.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247981",
    "data-name": "Path 247981",
    d: "M334.514,963.77l-14.2.009c-.054-.754.039-1.645,1.295-1.852a1.245,1.245,0,0,0,1.162-1.284h9.276c.271,1.261.9,1.261.9,1.261,2.153.146,1.564,1.864,1.564,1.864Z",
    transform: "translate(-32.592 -900.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247982",
    "data-name": "Path 247982",
    d: "M302.84,1098.452l.014-1.137a1.047,1.047,0,0,0-.788-.543c-.533-.04-14.531.04-14.531.04a1.441,1.441,0,0,0-.681.674l.013.966Z",
    transform: "translate(0 -1033.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247983",
    "data-name": "Path 247983",
    d: "M481.732,471.251a.52.52,0,0,1-.555.478h-5.285a.483.483,0,1,1,0-.955h5.285A.52.52,0,0,1,481.732,471.251Z",
    transform: "translate(-183.681 -422.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247984",
    "data-name": "Path 247984",
    d: "M518.61,403.69h4.176v1.055H518.61Z",
    transform: "translate(-225.844 -356.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247985",
    "data-name": "Path 247985",
    d: "M450.89,147.266c-.407.054-.42.451-.234.888a53.23,53.23,0,0,1,1.26,5.244l4.88.041s.469-3.8,1.222-5.135c0,0,.593-.956-.309-1.093s-6.411,0-6.819.054Z",
    transform: "translate(-159.52 -107.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247986",
    "data-name": "Path 247986",
    d: "M536.925,38.837h-.769l.05.892h-1.974l.05-.892h-.768v-.814h.813l.039-.709h1.705l.039.709h.813Z",
    transform: "translate(-240.365 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/king.695590d9bb751b79b1422a1ce17d639c.svg";
export { ForwardRef as ReactComponent };